import React from 'react'
import './Subabout.scss'
export default function Subsubabout() {
  return (
     <section className="subabout">
      <div className="subabout__container">
        <h2 className="subabout__title">J & M Tech Solutions</h2>
        <p className="subabout__desc">
          We build reliable technology foundations for your business. From
          cabling to connectivity, we make your network fast, secure, and
          future-ready.
        </p>

        <ul className="subabout__services">
          <li>Structured Cabling</li>
          <li>Switches & Servers</li>
          <li>Wireless Access Points</li>
          <li>Surveillance & CCTV</li>
        </ul>

        <p className="subabout__tagline">
          We design, install, and support every system we deliver — so you can
          focus on growth, not technology.
        </p>
      </div>
    </section>
  )
}

